export const ERROR_BOUNDARY_MESSAGE = {
  section: "Failed to load section. OneComply has been notified.",
  component: "Failed to load component. OneComply has been notified.",
};
